import React, { Component } from "react";

export default class DashboardTile extends Component {
  render() {
    const { selectedPathName, userId } = this.props;

    return (
      <li
        className={
          selectedPathName === "/dashboard" ||
          selectedPathName === `${"/" + userId}`
            ? "active"
            : ""
        }
        id="dashboard"
      >
        <a href="/dashboard" className="sideList">
          <img
            src={"/assets/icons/Dashboard.svg"}
            alt=""
            height="20"
            width="20"
            style={{ marginRight: 5 }}
          />
          <span className="sideText">Dashboard</span>
        </a>
      </li>
    );
  }
}
